class ListModalController {
  $onInit() {
    this.items = this.resolve.items;
    this.type = this.resolve.type;
  }

  submit() {
    this.close({ $value: this.selection });
  }

  selectItem($event, item) {
    $event.preventDefault();
    $event.stopPropagation();
    if (this.selection === item) {
      this.selection = null;
    } else {
      this.selection = item;
    }
  }

  cancel() {
    this.dismiss({ $value: 'cancel' });
  }
}

angular
  .module('pis-common.module')
  .controller('ListModalController', ListModalController);
